import { ReactNode } from 'react';
import AsyncSelect from 'react-select/async';
import { SingleValue } from 'react-select';
import {
  SearchableSelectOption,
  searchableSelectComponents,
} from './SearchableSelect';

interface AsyncSearchableSelectProps {
  ariaLabel: string;
  className?: string;
  emptyMessage?: string;
  inputId: string;
  isDisabled?: boolean;
  loadOptions: (query: string) => Promise<SearchableSelectOption[]>;
  loadingMessage?: string;
  onChange: (option: SearchableSelectOption | null) => void;
  placeholder: ReactNode;
  value: SearchableSelectOption | null;
}

export function AsyncSearchableSelect({
  ariaLabel,
  className,
  emptyMessage = 'Товары не найдены',
  inputId,
  isDisabled = false,
  loadOptions,
  loadingMessage = 'Ищем товары…',
  onChange,
  placeholder,
  value,
}: AsyncSearchableSelectProps) {
  const getNoOptionsMessage = ({ inputValue }: { inputValue: string }): string => {
    return inputValue.trim().length < 2
      ? 'Введите минимум 2 символа'
      : emptyMessage;
  };

  const handleChange = (option: SingleValue<SearchableSelectOption>): void => {
    onChange(option);
  };

  const searchOptions = (inputValue: string): Promise<SearchableSelectOption[]> => {
    const query = inputValue.trim();

    if (query.length < 2) {
      return Promise.resolve([]);
    }

    return loadOptions(query);
  };

  return (
    <AsyncSelect<SearchableSelectOption, false>
      aria-label={ariaLabel}
      cacheOptions
      className={['searchable-select', className].filter(Boolean).join(' ')}
      classNamePrefix="searchable-select"
      components={searchableSelectComponents}
      defaultOptions={false}
      inputId={inputId}
      isClearable
      isDisabled={isDisabled}
      isSearchable
      loadOptions={searchOptions}
      loadingMessage={() => loadingMessage}
      noOptionsMessage={getNoOptionsMessage}
      onChange={handleChange}
      placeholder={placeholder}
      unstyled
      value={value}
    />
  );
}
